<template>
    <div>
        <h2 class='subtitle is-dark'>
            名前を入力してエントリー
        </h2>
        <div class='box'>
            <div class='field is-grouped'>
                <p class='control is-expanded'>
                    <input class='input' type='text' v-model='name' placeholder='名前' maxlength='200' onfocus>
                </p>
                <p class='control'>
                    <button class='button is-info' @click='entry(name)'>
                        エントリー
                    </button>
                </p>
            </div>
        </div>
        <div v-if='peopleNum != 0'>
            {{peopleNum}}人がエントリー済み
        </div>
    </div>
</template>

<script>
import firebase from 'firebase/app'
export default {
    data(){
        return{
            name: '',
            db: this.$parent.$data.db,
            peopleNum: 0,
        }
    },
    mounted(){
        // エントリー済み人数をウォッチ
        this.db.doc(this.$store.state.id).onSnapshot(snapShot=>{
            this.peopleNum = snapShot.data().cnt
        })
    },
    methods:{
        entry: function(name){
            if(!name){
                this.$emit("alert", "名前を入力してください。");
                return false;
            }
            this.checkName(name);
        },
        checkName: function(myName){
            // 名前の重複がないか確認
            this.db.doc(this.$store.state.id).collection("name").where("name", "==", myName).get()
            .then(querySnapShot=>{
                if(querySnapShot.empty){
                    this.sendName(myName)
                }else{
                    this.$emit("alert", `名前が重複しています。<br>名前を少し変えてください。`);
                    return false;
                };
            })
            .catch(error=>{this.error(error)});
        },
        sendName: function(myName){
            this.db.doc(this.$store.state.id).collection("name").add({
                name: myName,
                select1: "",
                select2: "",
                select3: "",
                match: "",
                score: 0,
                created: firebase.firestore.FieldValue.serverTimestamp()
            })
            .then(doc=>{
                // 時間差でSelect.vueでうまく取得できないので、ここでも$storeに代入する
                this.$store.commit("setUid", doc.id);
                localStorage.setItem(`${this.$store.state.id}-select`, doc.id);
                this.$emit("conditionManager", "select");
                this.incEntry();
                // データを書き換えて、Select.vueを表示
                this.$parent.$data.condition = "select"
            })
            .catch(error=>{this.error(error);});
        },
        error: function(error){
            console.log(error);
            this.$emit('alert', `エラーが発生しました。<br>通信状況がいいところで再度試すか、<br>しばらくたってから再度試してください。`)
        },
        incEntry: function(){
            this.peopleNum++
            this.db.doc(this.$store.state.id).set({
                cnt: this.peopleNum,
            // 上書きの阻止
            },{merge: true})
            .catch(error=>{this.error(error);});
        }
    }
}
</script>
